import React, { useState } from 'react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

const EMPTY = { product_key: '', pattern: '{PREFIX}-{YY}{MM}-{SEQ:4}', prefix: '', reset: 'never' };

export const SerialPatternsPanel = ({ api, patterns, productOptions, onChanged }) => {
  const [f, setF] = useState(EMPTY);
  const save = async () => {
    try { await api().put('/serial-patterns', f); toast.success(`Pattern saved for ${f.product_key}`); setF(EMPTY); onChanged(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Save failed'); }
  };
  const del = async (k) => { await api().delete(`/serial-patterns/${encodeURIComponent(k)}`); onChanged(); };
  return (
    <div className="p-4 space-y-4" data-testid="serial-patterns-panel">
      <p className="text-xs text-slate-500">Tokens: <span className="mono">{'{PREFIX} {SKU} {YYYY} {YY} {MM} {DD} {SEQ:4}'}</span>. The counter runs per product with no gaps. Products without a pattern use <span className="mono">{'{SKU}-{YY}{MM}-{SEQ:4}'}</span>.</p>
      <div className="grid md:grid-cols-5 gap-2 items-end">
        <Input value={f.product_key} onChange={(e) => setF({ ...f, product_key: e.target.value })} list="sp-products" placeholder="Product SKU / name" className="rounded-sm mono" data-testid="sp-product-input" />
        <datalist id="sp-products">{(productOptions || []).map(p => <option key={p} value={p} />)}</datalist>
        <Input value={f.prefix} onChange={(e) => setF({ ...f, prefix: e.target.value })} placeholder="Prefix (e.g. PMP)" className="rounded-sm mono" data-testid="sp-prefix-input" />
        <Input value={f.pattern} onChange={(e) => setF({ ...f, pattern: e.target.value })} className="rounded-sm mono" data-testid="sp-pattern-input" />
        <select value={f.reset} onChange={(e) => setF({ ...f, reset: e.target.value })} className="h-9 border border-slate-200 rounded-sm text-sm px-2" data-testid="sp-reset-select">
          <option value="never">Never reset counter</option><option value="yearly">Reset yearly</option><option value="monthly">Reset monthly</option>
        </select>
        <Button onClick={save} disabled={!f.product_key} className="bg-slate-900 hover:bg-slate-800 rounded-sm" data-testid="sp-save-btn">Save pattern</Button>
      </div>
      <table className="w-full text-sm" data-testid="sp-table">
        <thead><tr className="text-[10px] uppercase text-slate-500 text-left"><th className="py-1">Product</th><th>Pattern</th><th>Prefix</th><th>Reset</th><th>Next serial</th><th /></tr></thead>
        <tbody>{patterns.map((p, i) => (
          <tr key={p.product_key} className="border-t border-slate-100" data-testid={`sp-row-${i}`}>
            <td className="mono py-1.5">{p.product_key}</td><td className="mono">{p.pattern}</td><td className="mono">{p.prefix || '—'}</td><td>{p.reset}</td>
            <td className="mono font-semibold" data-testid={`sp-next-${i}`}>{p.next_serial}</td>
            <td className="text-right whitespace-nowrap">
              <Button size="sm" variant="ghost" className="h-7" onClick={() => setF({ product_key: p.product_key, pattern: p.pattern, prefix: p.prefix || '', reset: p.reset })} data-testid={`sp-edit-${i}`}>Edit</Button>
              <Button size="sm" variant="ghost" className="h-7 text-red-600" onClick={() => del(p.product_key)} data-testid={`sp-delete-${i}`}>Remove</Button>
            </td>
          </tr>))}
          {!patterns.length && <tr><td colSpan={6} className="text-xs text-slate-400 py-3">No patterns yet.</td></tr>}
        </tbody>
      </table>
    </div>
  );
};

export default SerialPatternsPanel;
